import styled from 'styled-components';

import { Paper } from '@mui/material';

export const Section = styled.div`
    background: #ffffff;
    flex: 1;
    padding: 24px;
    border-radius: 16px;
`;

export const PaperTitle = styled.h2`
    font-size: 1.25rem;
    font-weight: 700;
    color: #25272e;
`;

export const Div = styled.div`
    display: flex;
    align-items: center;
    gap: 1.25rem;
    min-width: ${(props) => props.minWidth || null};
`;

export const Text = styled(PaperTitle)`
    font-weight: 400;
`;

export const ChartDiv = styled.div`
    width: 100%;
    height: ${(props) => (props.hasData ? '28.75rem' : '10rem')};
`;
